<template>
  <div class="lcpzBody">
    <el-container>
      <el-header height="50px">
        <div class="titleName">流程配置</div>
      </el-header>
      <el-container class="mainContent">
        <el-aside width="300px"
        ><el-tree
          lazy
          check-strictly
          ref="xzqhTree"
          show-checkbox
          node-key="value"
          :props="props"
          :load="loadNode"
          check-on-click-node
          @check-change="handleCheckChange"
        >
        </el-tree
        ></el-aside>
        <el-main class="rightContent">
          <div class="headerSearch">
            <div class="sousuo">
              <el-form
                ref="search"
                style="display: flex"
                label-position="left"
                label-width="90px"
              >
                <el-form-item label="业务类型">
                  <el-select
                    v-model="activeYwlx"
                    @change="yelxChange"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in ywlxOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="化学品类型" v-if="hxpFlag">
                  <el-cascader
                    v-model="activehxplx"
                    :options="HxpTree"
                    @change="hxplxChange"
                    placeholder="请选择"
                    :props="{ emitPath: false }"
                  >
                  </el-cascader>
                </el-form-item>
                <el-form-item label="化学品名称" v-if="hxpFlag">
                  <el-select
                    v-model="activehxpBm"
                    no-data-text="请选择化学品类型"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in activeHxpTree"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <div>
                <el-button
                  icon="el-icon-refresh-left"
                  type="primary"
                  plain
                  @click="reSetForm"
                >重置</el-button
                >
                <el-button type="primary" icon="el-icon-search" @click="affirm"
                >搜索</el-button
                >
              </div>
            </div>
          </div>
          <div class="bodyTable">
            <el-table
              stripe
              border
              :data="tableData"
              style="width: 100%"
              :header-cell-style="{
                borderRight: 'none',
                borderBottom: 'none',
                color: '#666',
              }"
            >
              <el-table-column
                prop="section"
                min-width="40%"
                label="部门"
                align="center"
              >
              </el-table-column>
              <el-table-column label="流程定义" align="center">
                <template slot-scope="scope">
                  <div
                    :style="{
                      display: 'flex',
                    }"
                  >
                    <div
                      :style="{
                        width: '33%',
                        display: 'flex',
                        'justify-content': 'center',
                        'align-items': 'center',
                      }"
                      v-for="(item, index) in scope.row.lcdy"
                      :key="index"
                      @click="checkedClick(item)"
                    >
                      <input
                        ref="curRef"
                        style="margin-right: 5px; background: pink"
                        type="checkbox"
                        :value="item.num"
                        v-model="checkedList"
                      />
                      <span style="width: 70px; text-align: left">{{
                        item.name
                      }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-button
              style="margin: 30px 0"
              @click="confirm"
              type="primary"
            >确认</el-button
            >
          </div>
          <div class="bodyFooter" v-for="(item, index) in lcList" :key="index">
            <p style="display: inline; margin-right: 30px">
              {{ item.ywlxLabel }}({{ item.hxpbmLabel }})
            </p>
            <!-- <el-button @click="reset(item)">清空</el-button> -->
            <!-- <el-button @click="selectStep(item)">选择</el-button> -->
            <!-- <el-button @click="deleteItem(item)">删除</el-button> -->
            <div class="stepsContainer">
              <el-steps :active="item.splcHjDtos.length + 2" align-center>
                <el-step class="firstStep">
                  <template slot="title">
                    <span class="startTitle">开始</span>
                  </template>
                  <template slot="title">
                    <span class="topIcon">
                      <img
                        src="../assets/img/kaishi1.png"
                        alt=""
                        srcset=""
                      />
                    </span>
                  </template>
                </el-step>
                <el-step
                  class="shenheStep"
                  v-for="(childrenItem, index) in item.splcHjDtos"
                  :key="index"
                >
                  <template slot="title">
                    <span class="startTitle">{{
                      childrenItem.js == 102
                        ? "审批"
                        : childrenItem.js == 103
                        ? "审核"
                        : "受理"
                    }}</span>
                  </template>
                  <template slot="title">
                    <span class="topIcon">
                      <img
                        :src="
                          childrenItem.js == 102
                            ? shenpiImg
                            : childrenItem.js == 103
                            ? shenheImg
                            : shouliImg
                        "
                        alt=""
                        srcset=""
                      />
                    </span>
                  </template>
                  <template slot="description">
                    <span class="descriptionCnotainer">
                      {{
                        childrenItem.js == 102
                          ? "审批"
                          : childrenItem.js == 103
                          ? "审核"
                          : "受理"
                      }}单位:{{ childrenItem.dwjbLabel }}
                    </span>
                  </template>
                </el-step>
                <el-step class="firstStep">
                  <template slot="title">
                    <span class="startTitle">结束</span>
                  </template>
                  <template slot="title">
                    <span class="topIcon">
                      <img
                        src="../assets/img/jieshu1.png"
                        alt=""
                        srcset=""
                      />
                    </span>
                  </template>
                </el-step>
              </el-steps>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
  import {
    getList,
    addOrUpdSave,
    getXzqTree,
    getXzqTreeS,
    getHxpTree,
    selSplcYwlx,
    selHxpXx,
  } from "@/assets/js/SplcPzym.js";
  export default {
    name: "SplcPzym",
    data() {
      return {
        props: {
          label: "label",
          key: "value",
          isLeaf: (data, node) => {
            return !data.leaf;
          },
        },
        tableData: [
          {
            section: "禁毒局",
            lcdy: [
              {
                name: "受理",
                num: 13,
              },
              {
                name: "审核",
                num: 14,
              },
              {
                name: "审批",
                num: 15,
              },
            ],
          },
          {
            section: "禁毒总队",
            lcdy: [
              {
                name: "总队受理",
                num: 10,
              },
              {
                name: "总队审核",
                num: 11,
              },
              {
                name: "总队审批",
                num: 12,
              },
            ],
          },
          {
            section: "禁毒支队",
            lcdy: [
              {
                name: "支队受理",
                num: 7,
              },
              {
                name: "支队审核",
                num: 8,
              },
              {
                name: "支队审批",
                num: 9,
              },
            ],
          },
          {
            section: "禁毒大队",
            lcdy: [
              {
                name: "大队受理",
                num: 4,
              },
              {
                name: "大队审核",
                num: 5,
              },
              {
                name: "大队审批",
                num: 6,
              },
            ],
          },
          {
            section: "派出所",
            lcdy: [
              {
                name: "派出所受理",
                num: 1,
              },
              {
                name: "派出所审核",
                num: 2,
              },
              {
                name: "派出所审批",
                num: 3,
              },
            ],
          },
        ],
        hxpFlag: false, //根据业务类型展示化学品
        HxpTree: [], //化学品类型
        activeHxpTree: [], //当前化学品类型
        ywlxOptions: [], //业务类型数组
        shenpiImg: require("@/assets/img/shenpi1.png"),
        shenheImg: require("@/assets/img/shenhe1.png"),
        shouliImg: require("@/assets/img/shouli1.png"),
        /*  */
        activeId: "", //当前id
        activehxplx: "", //当前化学品类型
        activehxpBm: "", //当前化学品编码
        activeNodeId: "", //当前选中区域Id
        activeYwlx: "", //当前选中业务类型
        checkedList: [],
        /*  */
        lcList: [], //流程数组
      };
    },
    mounted() {
      selSplcYwlx("yzd_spywlx").then((e) => {
        this.ywlxOptions = e.data.data;
      });
      //化学品树
      getHxpTree().then((e) => {
        this.HxpTree = e.data.data;
      });
    },
    methods: {
      checkedClick(curItem) {
        if (this.checkedList.indexOf(curItem.num) != -1) {
          this.checkedList.filter((item, index) => {
            if (item == curItem.num) {
              this.checkedList.splice(index, 1);
            }
          });
        } else {
          this.checkedList.push(curItem.num);
        }
      },
      yelxChange(val) {
        this.ywlxOptions.filter((item, index) => {
          if (item.value == val) {
            this.hxpFlag = item.other.hxpFlag;
          }
        });
      },
      reSetForm() {
        this.activeYwlx = "";
        this.activehxplx = "";
        this.activehxpBm = "";
        this.activeId = "";
        this.checkedList = [];
      },
      confirm() {
        this.$confirm("此操作将提交您的修改, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            if (typeof this.activeNodeId != "number") {
              this.$message.error("行政区划为必选项");
              return;
            }
            var data = {
              id: this.activeId,
              syqh: this.activeNodeId,
              ywlx: this.activeYwlx,
              hjEnum: this.checkedList,
              hxplb: this.activehxplx,
              hxpbm: this.activehxpBm,
            };
            addOrUpdSave(data).then((e) => {
              if (e.data.code == "000000") {
                this.affirm();
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      },
      selectStep(val) {
        this.activeId = val.id;
        this.activeYwlx = val.ywlx;
        this.activehxplx = val.hxplb;
        this.activehxpBm = val.hxpbm;
      },
      hxplxChange(value) {
        selHxpXx(value).then((e) => {
          this.activehxpBm = "";
          this.activeHxpTree = e.data.data;
        });
      },
      handleCheckChange(data, checked, node) {
        if (checked) {
          //实现单选功能
          this.activeNodeId = data.value;
          this.$refs.xzqhTree.setCheckedKeys([]);
          this.$refs.xzqhTree.setCheckedKeys([data.value]);
        }
      },
      loadNode(node, resolve) {
        if (node.level == 0) {
          getXzqTree().then((res) => {
            resolve([res.data.data]);
          });
        }
        if (node.level > 0) {
          if (node.data.isReq) {
            getXzqTreeS(node.data.value).then((res) => {
              resolve(res.data.data);
            });
          } else {
            return resolve(node.data.children);
          }
          return resolve([]); // 加上这个，防止在该节点没有子节点时一直转圈的问题发生。
        }
      },
      affirm() {
        if (typeof this.activeNodeId != "number") {
          this.$message.error("行政区划为必选项");
          return;
        }
        var data = {
          syqh: this.activeNodeId,
          ywlx: this.activeYwlx,
          hxplb: this.activehxplx,
          hxpbm: this.activehxpBm,
        };
        getList(data).then((e) => {
          this.lcList = e.data.data;
          if (this.lcList.length > 0) {
            this.activeId = this.lcList[0].id;
            this.activeYwlx = this.lcList[0].ywlx;
            this.activehxplx = this.lcList[0].hxplb;
            this.activehxpBm = this.lcList[0].hxpbm;
            this.checkedList = this.lcList[0].splcHjbhs;
          }
          if (this.lcList.length == 0) {
            this.$message("当前选项下暂无数据");
            this.checkedList = [];
          }
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .el-container {
    height: 100%;
  }
  .lcpzBody {
    background-color: #eee;
    height: calc(100%);
    .el-header {
      background-color: #fff;
      color: #333;
      line-height: 50px;
      width: 98%;
      margin: 10px auto;
      padding-top: 16px;
      padding-left: 0px;
      margin-bottom: 10px;
      .titleName {
        height: 18px;
        width: 90px;
        font-size: 18px;
        font-weight: 700;
        border-left: #2674e0 3px solid;
        color: #2674e0;
        line-height: 16px;
        text-align: center;
      }
      //margin: 10px 5px 15px 5px;
    }
    //@y1127
    .el-container .mainContent {
      width: 98%;
      margin: 0px auto;
      height: calc(100% - 70px);
      padding-bottom: 10px;
      .rightContent {
        background-color: #fff;
        margin-left: 10px;
        padding: 10px 20px;
        overflow-y: auto;
        .headerSearch {
          margin-top: 20px;
          .sousuo {
            display: flex;
            justify-content: space-between;
          }
          .el-form {
            .el-form-item {
              margin-bottom: 0;
              margin-right: 15px;
            }
          }
        }
        .bodyTable {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 30px;
          /deep/.el-table td,
          .el-table th.is-leaf {
            border: none;
          }
        }
        .bodyFooter {
          p {
            color: #666;
          }
        }
        .el-select {
          width: 100%;
        }
        .el-form-item {
          margin-right: 10px;
          /deep/.el-form-item__label {
            color: #666;
            font-weight: 400;
          }
        }
      }
    }
    /deep/.el-aside {
      background-color: #fff;
      padding: 20px 30px 20px 10px;
    }
  }
  input[type="checkbox"] + label > i {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 1px solid #bbb;
    background: #fff;
    margin-right: 5px;
    vertical-align: middle;
    border-radius: 5px;
    top: -1px;
  }
  .stepsContainer {
    margin: 70px auto 0px auto;
    .firstStep,
    .shenheStep {
      position: relative;
      .startTitle {
        width: 60px;
        display: inline-block;
        height: 25px;
        line-height: 25px;
        text-align: center;
        border-radius: 20px;
        background-color: #9cc7f4;
        color: white;
        margin-top: 15px;
        margin-bottom: 0px;
      }
      .shenpi {
        background-color: #999;
      }
      .over {
        background-color: #999;
      }
      .topIcon {
        width: 100px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -25px;
      }
      .descriptionCnotainer {
        width: 200px;
        height: 30px;
        line-height: 30px;
        // font-weight: 700;
        color: #333;
      }
    }

    /deep/.el-step__icon {
      width: 10px;
      height: 10px;
      margin-top: 7px;
      background-color: #9cc7f4;
      border: none;
    }
    /deep/.el-step__icon-inner {
      display: none;
    }
  }
  ::-webkit-scrollbar-track {
    border-radius: 8px;
    -webkit-box-shodow: inset 0 0 6px rgba(240, 240, 240, 0.3);
    background-color: #f5f5f5;
  }
  ::-webkit-scrollbar {
    width: 4px;
    border-radius: 8px;
    background-color: #f5f5f5;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-image: -webkit-gradient(
      linear,
      left bottom,
      left top,
      color-stop(1, rgb(100, 100, 100))
    );
  }
</style>
